import { render, staticRenderFns } from "./Analisi.vue?vue&type=template&id=5be69158&scoped=true"
import script from "./Analisi.vue?vue&type=script&lang=js"
export * from "./Analisi.vue?vue&type=script&lang=js"
import style0 from "./Analisi.vue?vue&type=style&index=0&id=5be69158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be69158",
  null
  
)

export default component.exports